import { Component, inject, input, model, signal } from '@angular/core';
import { ProductService } from 'src/app/admin-dashboard/product/product.service';
import { SystemService } from '../../../../services/system.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfigService } from 'src/app/shared/config';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { NotificationService } from 'src/app/shared/notification.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Location } from '@angular/common';

interface FoodItem {
  name: string;
  values: boolean[];
  input: number;
  id: string,
  updateId?: string,
  oldValue?: number
}


@Component({
  selector: 'app-svinn',
  templateUrl: './svinn.component.html',
  styleUrl: './svinn.component.css'
})
export class SvinnComponent {
  foodItems: FoodItem[] = []
  params: Params
  systemId: string = ''
  siteId: string = ''
  debug = {};
  readonly animal = signal('');
  readonly name = model('');
  readonly dialog = inject(MatDialog);
  searchTerm: string = '';
  isSaving = false;

  constructor(private notifierService: NotificationService, private config: ConfigService, private productService: ProductService, private systemService: SystemService, private route: ActivatedRoute) {

    this.route.params.subscribe(param => {
      console.log(param)
      this.params = param
      this.systemId = param['systemId']
      this.siteId = param['siteId']

      this.systemService.getSvinnData(this.systemId).then(data => {
        console.log("Hello")
        console.log(data)

        this.productService.getAllSvinnActiveCategories().subscribe(sp => {
          sp.forEach(doc => {
            this.foodItems.push({ id: doc.id, name: doc.data()['name'], values: Array(9).fill(false), input: 0 })
          })

          console.log(this.foodItems)
          console.log(data);

          this.foodItems.forEach(foodItem => {
            const matchingData = data.find((item: any) => item.doc.name === foodItem.name);
            if (matchingData) {
              console.log("matchingData")
              console.log((matchingData.doc as any).number);

              foodItem.input = (matchingData.doc as any).number;
              foodItem.updateId = matchingData.id;
              foodItem.oldValue = (matchingData.doc as any).number;
              console.log((matchingData.doc as any).name, foodItem.updateId)
              // foodItem.input = matchingData.doc.input;
            }
          })
        })



      });

    })





    // this.systemService.getSvinnData()
  }

  numbers = Array.from({ length: 9 }, (_, i) => i + 1); // [1, 2, 3, ..., 9]

  models = Array.from({ length: 9 }, () => 0);

  get filteredFoodItems() {
    if (!this.searchTerm) return this.foodItems;
    return this.foodItems.filter(item => 
      item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  increment(item: FoodItem) {
    item.input = (Number(item.input) || 0) + 1;
    this.inputChanged(item, 0);
  }

  decrement(item: FoodItem) {
    if (item.input > 0) {
      item.input = (Number(item.input) || 0) - 1;
      this.inputChanged(item, 0);
    }
  }


  inputChanged(item: FoodItem, index: number) {
    console.log(item, index, item.input)
    console.log(this.models);



    this.debug = item;
  }

  onFieldClick(event) {
    event.target.select()
  }


  onSubmit() {
    this.isSaving = true;
    const timestamp = new Date(); // Capture the current time
    const recordsToSave = [];


    this.foodItems.forEach(item => {

      if (item.input == 0 || item.input == null) return
      if (item.oldValue && item.input == item.oldValue) return

      recordsToSave.push({
        name: item.name,
        id: item.id,
        number: item.input,
        input: item.input,
        ...this.params,
        companyId: this.config.getCompanyId(),
        [item.name.toLowerCase()]: item.input,
        timestamp: timestamp,
        updateId: item.updateId ? item.updateId : null,
        unix: moment().unix()
      });
    })

    console.log(recordsToSave)
    if (recordsToSave.length === 0) {
      this.isSaving = false;
      this.notifierService.showNotification('warning', 'No changes to save');
      return;
    }

    // this.foodItems.forEach(item => {
    //   item.values.forEach((isSelected, index) => {
    //     if (isSelected) {
    //       let checkAvailability = recordsToSave.findIndex(i => i.id == item.id)
    //       if (checkAvailability > -1) {
    //         recordsToSave[checkAvailability].number = recordsToSave[checkAvailability].number + index + 1
    //         recordsToSave[checkAvailability][item.name.toLowerCase()] = recordsToSave[checkAvailability][item.name.toLowerCase()] + index + 1

    //       }
    //       else
    //         recordsToSave.push({
    //           name: item.name,
    //           id: item.id,
    //           number: index + 1,
    //           input: item.input,
    //           ...this.params,
    //           companyId: this.config.getCompanyId(),
    //           [item.name.toLowerCase()]: index + 1,
    //           timestamp: timestamp,
    //           unix: moment().unix()
    //         });
    //     }
    //   });
    // });


    // recordsToSave.forEach(doc=>{
    this.systemService.addSvinn(recordsToSave).then(data => {
      // console.log(data)
      this.isSaving = false;
      this.openDialog()
      this.notifierService.showNotification('success', `Successfully uploaded`);
    }).catch(err => {
      this.isSaving = false;
      this.notifierService.showNotification('error', err);

      // })
    })



    // this.saveData(recordsToSave).subscribe(response => {
    //   console.log('Data saved', response);
    // }, error => {
    //   console.error('Error saving data', error);
    // });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result !== undefined) {
        this.animal.set(result);
      }
    });
  }
  saveData(data: any) {
    // console.log(data)
    // Replace 'your-backend-endpoint' with the actual URL of your backend service
    // return this.http.post('your-backend-endpoint', data);
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'svinnconfirmation.dialog.html',
  styleUrl: 'svinnconfirmation.dialog.css'
})

export class DialogOverviewExampleDialog {
  constructor(private _location: Location, public route: ActivatedRoute, public router: Router, public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
  ) {
    dialogRef.disableClose = true;
  }

  onNoClick() {
    this._location.back()

    this.dialogRef.close();
    this.router.navigate(['../'], { relativeTo: this.route })

  }
}